import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
interface PageHeroProps {
  image: string;
  imageAlt: string;
  title: string;
  intro: string;
  crumb: string;
  children?: React.ReactNode;
  imagePosition?: string;
}
export function PageHero({
  image,
  imageAlt,
  title,
  intro,
  crumb,
  children,
  imagePosition = 'center'
}: PageHeroProps) {
  return <section className="relative -mt-[76px] overflow-hidden bg-ink" data-id="element-361" data-mp="r26c5shz74xq">
      <img src={image} alt={imageAlt} className="absolute inset-0 h-full w-full object-cover" style={{
      objectPosition: imagePosition
    }} data-id="element-362" data-mp="r4k3bq9jbx00" />
      <div className="absolute inset-0 bg-ink/60" aria-hidden="true" data-id="element-363" data-mp="hc4lqu25hafn" />
      <div className="relative mx-auto max-w-[1440px] px-4 pb-16 pt-[170px] text-canvas sm:px-6 lg:px-10 lg:pb-24 lg:pt-[230px]" data-id="element-364" data-mp="haa4pqu022gu">
        <nav aria-label="Kruimelpad" data-id="element-365" data-mp="19t79kc3g6sf6">
          <ol className="flex items-center gap-1.5 text-[14px] text-canvas/70" data-id="element-366" data-mp="19u8leisafixy">
            <li data-id="element-367" data-mp="151fhfx4n8emx">
              <Link to="/" className="hover:text-canvas" data-id="element-368" data-mp="150xnj75geci6">Home</Link>
            </li>
            <li aria-hidden="true" data-id="element-369" data-mp="2pyd7cjxnxos9">
              <ChevronRightIcon className="h-3.5 w-3.5" data-id="element-370" data-mp="2pzelix9z6re7" />
            </li>
            <li aria-current="page" className="text-canvas" data-id="element-371" data-mp="2uvloqiazlosg">{crumb}</li>
          </ol>
        </nav>
        <h1 className="mt-5 max-w-4xl text-5xl font-semibold leading-[0.96] tracking-tightest sm:text-7xl lg:text-[84px]" data-id="element-372" data-mp="2g6pk6v852twl">{title}</h1>
        <p className="mt-6 max-w-xl text-lg leading-relaxed text-canvas/80 sm:text-xl" data-id="element-373" data-mp="276kgav25mdn6">{intro}</p>
        {children && <div className="mt-10" data-id="element-374" data-mp="2c5dw4u4wygqi">{children}</div>}
      </div>
    </section>;
}